module.exports = __webpack_public_path__ + "shanz/static/media/12.9c08b2d0.png";